import {
  faComment,
  faCommentDots,
  faBookmark as farBookmark,
  faHeart as farHeart,
} from "@fortawesome/free-regular-svg-icons";
import {
  faEllipsisH,
  faSpinner,
  faBookmark as fasBookmark,
  faHeart as fasHeart,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dropdown, Spinner } from "react-bootstrap";
import images from "../../assets/images";
import "../../screens/community/style.css";

const PostsTab = ({
  posts,
  isLoading,
  isRefetching,
  user,
  navigate,
  loadingActions,
  commentInputs,
  handleCommentChange,
  handlePostComment,
  handleToggleAction,
  isLiked,
  isSaved,
  handleEditPost,
  handleDeletePost,
  handleReportPost,
  handleCopyLink,
  isAdminOrModerator,
  t,
}) => {
  if (isLoading)
    return (
      <p className="justify-content-center text-center">
        <Spinner />
      </p>
    );

  if (!isLoading && !isRefetching && posts?.length === 0) {
    return (
      <p className="justify-content-center text-center text-muted">
        {t("noPostFound")}
      </p>
    );
  }

  return (
    <div className="row g-3">
      {posts?.map((post) => (
        <div key={post._id} className="col-12 col-sm-6 col-lg-4">
          <div
            className="card community-post shadow-sm h-100 p-2 d-flex flex-column"
            style={{ backgroundColor: "#161617" }}
          >
            <div className="post-media-container mb-0">
              {/* HEADER OVERLAY */}
              <div className="post-header-overlay">
                <div className="user-info">
                  <img
                    src={
                      post?.user?.picture
                        ? post.user.picture.startsWith("https")
                          ? post.user.picture
                          : `${process.env.REACT_APP_S3_BASE_URL}${post.user.picture}`
                        : images.profile.placeholder
                    }
                    alt="avatar"
                    className="avatar"
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate(
                        `${
                          post?.user?.role === "learner"
                            ? `/learner/${post?.user?._id}`
                            : `/instructor/${post?.user?._id}`
                        }`,
                      );
                    }}
                  />

                  <div className="left">
                    <div
                      className="user-name"
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate(
                          `${
                            post?.user?.role === "learner"
                              ? `/learner/${post?.user?._id}`
                              : `/instructor/${post?.user?._id}`
                          }`,
                        );
                      }}
                    >
                      {post?.user?.first_name} {post?.user?.last_name}
                    </div>
                    <div className="post-content">{post?.content}</div>
                    <div className="post-date">
                      {new Date(post?.createdAt).toLocaleString("en-US", {
                        month: "long",
                        year: "numeric",
                      })}
                    </div>
                  </div>
                </div>
              </div>

              {/* IMAGE */}
              {post?.imgorgif ? (
                <img
                  src={
                    post.imgorgif?.startsWith("https")
                      ? post.imgorgif
                      : `${process.env.REACT_APP_S3_BASE_URL}${post.imgorgif}`
                  }
                  alt="post media"
                  className="post-media"
                />
              ) : (
                <div className="post-text-only">
                  <p>{post?.content}</p>
                </div>
              )}
            </div>

            {/* ACTIONS (RIGHT SIDE) */}
            <div className="post-actions">
              <button
                className="d-flex gap-2"
                onClick={() => handleToggleAction(post._id, "like")}
                disabled={loadingActions[`${post._id}-like`]}
              >
                <span style={{ fontWeight: "700" }}>{post?.like || 0}</span>
                <FontAwesomeIcon
                  color="var(--primaryColor)"
                  icon={isLiked(post._id) ? fasHeart : farHeart}
                />
              </button>

              <button
                className="d-flex gap-2"
                onClick={() => handleToggleAction(post._id, "save")}
                disabled={loadingActions[`${post._id}-save`]}
              >
                <span style={{ fontWeight: "700" }}>{post?.save || 0}</span>
                <FontAwesomeIcon
                  className="ps-1"
                  color="var(--primaryColor)"
                  icon={isSaved(post._id) ? fasBookmark : farBookmark}
                />
              </button>

              <button
                className="d-flex gap-2"
                onClick={() => navigate(`/community/${post._id}`)}
              >
                <span style={{ fontWeight: "700" }}>{post?.comments || 0}</span>
                <FontAwesomeIcon icon={faComment} color="var(--primaryColor)" />
              </button>

              <Dropdown className="align-self-end me-1">
                <Dropdown.Toggle className="dots-toggle">
                  <FontAwesomeIcon
                    icon={faEllipsisH}
                    color="var(--primaryColor)"
                  />
                </Dropdown.Toggle>
                <Dropdown.Menu align="end">
                  <Dropdown.Item
                    onClick={() => navigate(`/community/${post._id}`)}
                  >
                    {t("viewPost")}
                  </Dropdown.Item>

                  {post?.user?._id === user?._id && (
                    <Dropdown.Item onClick={() => handleEditPost(post._id)}>
                      {t("editPost")}
                    </Dropdown.Item>
                  )}

                  {(post?.user?._id === user?._id || isAdminOrModerator) && (
                    <Dropdown.Item onClick={() => handleDeletePost(post._id)}>
                      {t("deletePost")}
                    </Dropdown.Item>
                  )}

                  <Dropdown.Item onClick={() => handleReportPost(post._id)}>
                    {t("reportPost")}
                  </Dropdown.Item>

                  <Dropdown.Item onClick={() => handleCopyLink(post._id)}>
                    {t("copyLink")}
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default PostsTab;
